import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, RedirectRequest } from '@azure/msal-browser';
import { AuthService } from 'src/app/service/auth.service';
import { HttpService } from 'src/app/service/http.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    private httpService: HttpService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.route.fragment.subscribe(fragment => {
      if(fragment) {
        const params = new URLSearchParams(fragment);
        const code = params.get('code');
  
        if (code) {
          this.exchangeCodeForToken(code, this.authService.getCodeVerifier());
        }
      }
      else {
        setTimeout(() => {
          this.authService.login();
        }, 2000)
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  exchangeCodeForToken(code: string, codeVerifier) {
    const authCodeRequest = { 
      Code: code,
      CodeVerifier: codeVerifier,
      RedirectUri: environment.redirectUrl
    }; 

    this.authService.authenticate(authCodeRequest).subscribe({
      next: (response) => {
        console.log(response);
        if(response)
        {
          this.toastr.success('Tracking Bemol', 'Seja bem vindo(a)');
          this.router.navigate(['/dashboard']);
        }
      },
      error: (error) => {
        console.log('Erro na autenticação: ', error);
        this.toastr.error('Usuário sem permissão.');
      },
    });
  }
}
